import React, { Component } from 'react';
import { string, arrayOf, shape, number } from 'prop-types';
import { Message } from 'semantic-ui-react';

import Feed from '../components/Feed';
import getEpisodes from '../components/getEpisodes';

const initialState = { episodes: [], loading: true };

class Episodes extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
  }

  componentDidMount() {
    const { videos, ytKey, languageId, match } = this.props;
    getEpisodes(videos, ytKey, languageId, match)
      .then(res => {
        this.setState({
          loading: false,
          episodes: res,
        });
      })
      .catch(() =>
        this.setState({ loading: false, err: 'Error loading data' })
      );
  }

  render() {
    const { episodes, loading, err } = this.state;
    const { terms } = this.props;
    return (
      <div>
        {!err ? (
          <Feed episodes={episodes} loading={loading} terms={terms} />
        ) : (
          <Message negative header="Error" content={err} />
        )}
      </div>
    );
  }
}

Episodes.propTypes = {
  videos: arrayOf(shape()).isRequired,
  ytKey: string.isRequired,
  languageId: number.isRequired,
  terms: arrayOf(string).isRequired,
  match: shape().isRequired,
};

export default Episodes;



// WEBPACK FOOTER //
// ./src/Routes/Episodes.jsx